import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InsertImageIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "InsertImage",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.51 4h-19C4.02 4 2.01 6.01 2 8.5v15c0 2.48 2.01 4.49 4.49 4.5h19c2.48 0 4.49-2 4.51-4.47V8.5c0-2.48-2.01-4.49-4.49-4.5M27 23.53c0 .83-.67 1.5-1.5 1.5h-19c-.83 0-1.5-.67-1.5-1.5V8.5c0-.82.67-1.49 1.49-1.5H25.5c.83 0 1.5.67 1.5 1.5zm-2.94-11.42a1.505 1.505 0 0 0-1.66.4s-6 7-6 7c-.09.11-.23.17-.38.17-.08 0-.16-.02-.23-.06s-3-3.3-3-3.3c-.25-.2-.57-.32-.92-.32-.08 0-.15 0-.23.02-.41.05-.77.26-1 .57s-3.38 4-3.38 4c-.18.25-.29.56-.29.89 0 .83.67 1.5 1.5 1.5h15.01c.83 0 1.5-.67 1.5-1.5v-8c0-.63-.38-1.16-.92-1.39h-.01Zm-13.07-1.1c0 1.1-.9 2-2 2s-2-.9-2-2 .89-2 2-2 2 .89 2 2"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43v-16c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43M3.29 7.14c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h25.14c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "7.35",
        cy: "12.35",
        r: ".63"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.35 14.13c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78 1.78.8 1.78 1.78-.8 1.78-1.78 1.78m0-2.29c-.28 0-.51.23-.51.51s.23.51.51.51.51-.23.51-.51-.23-.51-.51-.51M5.58 23.12c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l4.09-4.09c1.3-1.3 3.55-1.3 4.85 0l1.33 1.33c.43.43 1.18.43 1.62 0l3.63-3.63c1.3-1.3 3.55-1.3 4.85 0l1.84 1.84c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-1.84-1.84c-.43-.43-1.18-.43-1.62 0l-3.63 3.63c-1.29 1.3-3.55 1.3-4.85 0l-1.33-1.33c-.43-.43-1.18-.43-1.62 0l-4.09 4.09c-.22.22-.52.33-.81.33Z"
      })]
    })
  }));
};